export function isUserOnMac() {
  return /mac/i.test(navigator.userAgent);
}
